import { css } from '@emotion/react';
import { Grid, styled } from '@mui/material';
import type { ReactNode } from 'react';

import { SectionTabs } from '@/components/management/form/formHelpers/SectionTabs';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';
import { SCREEN_HEIGHT_BREAKPOINT } from '@/modules/SCREEN_HEIGHT_BREAKPOINT';

const TabGridWrapper = styled(Grid)(
  ({ theme }) => css`
    position: sticky;
    top: 0;
    background-color: ${theme.palette.common.white};
    z-index: 100;
    align-self: flex-start;
    padding: ${theme.spacing(1)} ${theme.spacing(0)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      padding: inherit;
      top: ${theme.spacing(8)};
    }

    @media (min-height: ${SCREEN_HEIGHT_BREAKPOINT}) and (min-width: ${theme.breakpoints.values[MAIN_BREAKPOINT]}px) {
      top: ${theme.spacing(8 + 15 + 8)};
    }
  `,
);

interface FormGridLayoutProps {
  tabs: string[];
  children: ReactNode;
  activeTab: number;
  onTabChange: (index: number) => void;
}

export function FormGridLayout({ tabs, children, activeTab, onTabChange }: FormGridLayoutProps) {
  return (
    <Grid container direction={{ md: 'column', lg: 'row' }} spacing={{ md: 2, lg: 4 }}>
      <TabGridWrapper size={{ md: 12, lg: 2.5 }}>
        <SectionTabs onChange={onTabChange} tabs={tabs} value={activeTab} />
      </TabGridWrapper>
      <Grid size={{ md: 12, lg: 7 }}>{children}</Grid>
      <Grid size={{ md: 0, lg: 2.5 }} />
    </Grid>
  );
}
